import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { api } from '../../api';
import toast from 'react-hot-toast';

const QuizReview: React.FC = () => {
  const { attemptId } = useParams();
  const navigate = useNavigate();
  const [attempt, setAttempt] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAttempt = async () => {
      try {
        const response = await api.get(`/quizzes/review/${attemptId}`);
        setAttempt(response.data.data);
      } catch (error) {
        console.error('Error loading quiz attempt:', error);
        toast.error('Erreur lors du chargement de la tentative de quiz');
        navigate('/admin/quizzes');
      } finally {
        setLoading(false);
      }
    };

    fetchAttempt();
  }, [attemptId, navigate]);

  const handleGrade = async (newScore: number) => {
    try {
      await api.put(`/quizzes/review/${attemptId}`,
        {
          score: newScore,
          status: 'graded'
        });
      toast.success('Note enregistrée avec succès');
      navigate('/admin/quizzes');
    } catch (error) {
      console.error('Error grading quiz attempt:', error);
      toast.error('Erreur lors de l\'enregistrement de la note');
    }
  }

  if (loading) {
    return <Layout><div>Chargement...</div></Layout>;
  }

  if (!attempt) {
    return <Layout><div>Tentative de quiz non trouvée.</div></Layout>;
  }

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold text-gray-900">Correction du Quiz: {attempt.quiz.title}</h1>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <p className="text-gray-600 mb-4">Tentative de: {attempt.student.name}</p>
          {attempt.answers.map((answer: any, index: number) => (
            <div key={answer.questionId} className="mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Question {index + 1}: {answer.question.text}</h3>
              <div className="space-y-2 mt-2">
                <p>Réponse de l'étudiant: {answer.answer}</p>
              </div>
            </div>
          ))}
          <div className="mt-6">
            <label htmlFor="score" className="block text-sm font-medium text-gray-700">Note finale</label>
            <input type="number" id="score" name="score" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#FFB639] focus:border-[#FFB639] sm:text-sm" />
            <button onClick={() => handleGrade(50)} className="mt-4 px-4 py-2 bg-[#FFB639] text-white rounded-lg hover:bg-[#e5a333] transition-colors">Enregistrer la note</button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default QuizReview;